module.exports = __webpack_public_path__ + "img/zoe_estates_bg_room_003.cae992c7.jpg";